export default __webpack_public_path__ + "static/data-vis-color-role-do-6f975d1167b10799a4438076e71a1902.png";